export const transaksiKeluarFilter = (
  dropdownTahunAnggaranPengeluaran,
  dropdownUnitUsaha
) => {
  return [
    {
      id: "tahun",
      label: "Tahun",
      options: dropdownTahunAnggaranPengeluaran,
    },
    {
      id: "id_unit_usaha",
      label: "Unit Usaha",
      options: dropdownUnitUsaha,
    },
  ];
};
